import React, { Component } from 'react'
import { render } from 'react-dom'

import { InlineMath, BlockMath } from 'react-katex';

import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dark, darcula } from 'react-syntax-highlighter/dist/esm/styles/prism';

import {
  Header,
} from 'semantic-ui-react'

import 'katex/dist/katex.min.css';

class Chapter301 extends Component {
  render() {
    return (
      <div className="base">

        <Header as='h1'>
        3. Repeat Buying
        </Header>

　Ehrenberg先生の有名な論文「Repeat-Buying」は「確率試行の戦略論」の仲でも最も引用されている論文です。また、本ホームページで開設してきた数学的なバックグランドはすべてこの論文から引用されていると言っても過言ではありません。本章では、「確率試行の戦略論」の理解に必要な部分を中心に開設を行います。 <br/>

        <Header as='h2'>
        長期平均購入回数<InlineMath>{`\\displaystyle \\mu `}</InlineMath>をガンマ分布で表現する根拠
        </Header>

　Eherenberg先生の論文ではガンマ分布を仮定することに直接的な根拠は上げていません。厳密な仮定でないことも明言されています。実際に得られたデータを再現できること、フィッティングパラメタとして二つの変数を持つ事が上げられています。 <br/>

        <img style={{"width":"100%", "margin":"0 auto"}} src={`${process.env.PUBLIC_URL}/images/02.png`} alt="02" />
        <img style={{"width":"100%", "margin":"0 auto"}} src={`${process.env.PUBLIC_URL}/images/03.png`} alt="03" />

　また、ポアソン分布とガンマ分布の混合分布の結果として、負の二項分布が導かれる事も本論文に記述されています。以下の表は「確率試行の戦略論」でも取り上げられている表に似ています。著者もこの論文を参考に表を作ったものと思われます。 <br/>

        <img style={{"width":"100%", "margin":"0 auto"}} src={`${process.env.PUBLIC_URL}/images/01.png`} alt="01" />

      </div>
    )   
  }
}

export default Chapter301;
